import React from 'react'
import {checkboxHolderStyle} from './checkbox-holder-style'
import {Form} from 'semantic-ui-react'

const shareOrderTypeCategoryInput = (customAccessFieldOnChange, shareOrderTypeCategory) => {
  return (
    <div style={checkboxHolderStyle}>
      <b>Share &#123;order-type&#125; on &#123;category&#125;:</b>
      <Form.Group widths='equal' style={{textAlign: 'center'}}>
        <Form.Input name='shareOrderTypeCategory' type="text" label='' onChange={customAccessFieldOnChange} placeholder='Hold on SLEEP / LOUNGE' value={shareOrderTypeCategory}
          style={{width: '500px'}} />
      </Form.Group>
    </div>
  )
}

export {shareOrderTypeCategoryInput}
